export const Sales_Help_Resources = [
  {
    header: 'AT&T Resources',
    items: [
      {
        title: 'Assurant Tool',
        description: null,
        links: [{ label: 'Click here to access', url: 'https://directv360.my.salesforce.com/' }]
      },
      {
        title: 'AT&T Mobile Sales Tool',
        description: 'A Pocket Guide for all AT&T Products. A great tool for them to assist a customer with questions about our other products and help them become familiar with the products and pricing.',
        links: [{ label: 'Click here to access', url: 'https://directv360.my.salesforce.com/' }]
      }
    ]
  },
  {
    header: 'DIRECTV Resources',
    items: [
      {
        title: 'CCKM',
        description: null,
        links: [{ label: 'Click here to access', url: 'https://directv360.my.salesforce.com/' }]
      },
      {
        title: 'LSP',
        description: null,
        links: [{ label: 'Click here to access', url: 'https://www.directv.com/tools/agent-package-compare-tool/lsp/' }]
      },
      {
        title: 'D2D',
        description: null,
        links: [{ label: 'Click here to access', url: 'https://www.directv.com/tools/agent-package-compare-tool/d2d/' }]
      },
      {
        title: 'EM',
        description: null,
        links: [{ label: 'Click here to access', url: 'https://www.directv.com/tools/agent-package-compare-tool/em/' }]
      },
      {
        title: 'MDU',
        description: null,
        links: [{ label: 'Click here to access', url: 'https://www.directv.com/tools/agent-package-compare-tool/mdu/' }]
      },
      {
        title: 'DAP',
        description: null,
        links: [{ label: 'Click here to access', url: 'https://www.directv.com/tools/agent-package-compare-tool/dap/' }]
      },
      {
        title: 'ND',
        description: null,
        links: [{ label: 'Click here to access', url: 'https://www.directv.com/tools/agent-package-compare-tool/nd/' }]
      },
      {
        title: 'Direct Sales',
        description: null,
        links: [{ label: 'Click here to access', url: 'https://www.directv.com/tools/agent-package-compare-tool' }]
      },
      {
        title: 'ISP',
        description: null,
        links: [{ label: 'Click here to access', url: 'https://www.directv.com/tools/agent-package-compare-tool/isp/' }]
      },
      {
        title: 'Channel Line Up',
        description: null,
        links: [{ label: 'Click here to access', url: 'https://www.directv.com/channel-lineup/' }]
      },
      {
        title: 'RSN Fee Checker',
        description: null,
        links: [{ label: 'Click here to access', url: 'https://www.directv.com/sports/regional-sports-fee/' }]
      },
      {
        title: 'DIRECTV.com Support',
        description: null,
        links: [{ label: 'Click here to access', url: 'https://www.directv.com/support' }]
      }
    ]
  }
];